import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getMentorshipsApplicationId(applicationId: string) {
  return await prisma.applicantMentorship.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
